import { render, staticRenderFns } from "./UpdateOrderTrackingListModal.vue?vue&type=template&id=67657425&scoped=true&"
import script from "./UpdateOrderTrackingListModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateOrderTrackingListModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateOrderTrackingListModal.vue?vue&type=style&index=0&id=67657425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67657425",
  null
  
)

export default component.exports